import { commonWebSocket } from '@services/common/common.constants';
import { createReducer } from 'redux-act';
import { ICall, ICallData } from '@app-types/websocket/calls.types';
import { isCallActive } from './calls.utils';
import { callNotification, newCall } from './calls.actions';

const defaultState:{
  calls:ICall[],
  callData:ICallData|undefined,
  callNotificationTime:number,
  callNotificationCallId:number,
  callRequestChatId:number,
  callRequestTime:number,
} = {
  calls : [],
  callData:undefined,
  callNotificationTime:0,
  callNotificationCallId:0,
  callRequestChatId:0,
  callRequestTime:0,
};

const reducer = createReducer<typeof defaultState>({}, defaultState);

/**
 * Call updates can arrive out of order: several backend threads broadcast the same call,
 * and a slower one must not undo a newer state. A call that has finished never restarts,
 * and details that only later messages carry are kept when an update omits them.
 */
function mergeCall(existing:ICall, incoming:ICall): ICall {
  if (!isCallActive(existing) && isCallActive(incoming)) {
    return existing;
  }

  return {
    ...incoming,
    externalId: incoming.externalId ? incoming.externalId : existing.externalId,
    recording: incoming.recording ? incoming.recording : existing.recording,
  };
}

reducer 
  .on(callNotification, (state: any, payload: any) => {

    return {
      ...state,
      callNotificationTime:Date.now(),
      callNotificationCallId:payload,
    };
  })
  .on(newCall, (state: any, payload: any) => {
    // The same account can be signed in on a phone and a computer at once, and both are
    // told about every call. This store is per device, so remembering the request here is
    // what lets the call UI tell "I placed this call" from "my other device placed it".
    return {
      ...state,
      callRequestChatId: payload && payload.chatId ? payload.chatId : 0,
      callRequestTime: Date.now(),
    };
  })
  .on(commonWebSocket.replace.CALLS, (state: any, payload: any) => {
    if (!Array.isArray(payload?.calls)) {
      return state;
    }

    const oldCalls:ICall[] = Array.isArray(state.calls) ? state.calls.slice() : [];
    for (const call of payload.calls) {
      if (!call || call.id === undefined) {
        continue;
      }

      const normalizedCall:ICall = {
        ...call,
        participants: Array.isArray(call.participants)
          ? call.participants.filter((participant:any) => participant !== undefined && participant !== null)
          : [],
      };

      const index = oldCalls.findIndex((c:ICall) => c.id === normalizedCall.id);
      if (index > -1) {
        oldCalls[index] = mergeCall(oldCalls[index], normalizedCall);
      } else {
        oldCalls.push(normalizedCall);
      }
    }

    return {
      ...state,
      calls:oldCalls,
    };
  })
  .on(commonWebSocket.replace.CALL_DATA, (state: any, payload: any) => {
    if (!payload?.callData || typeof payload.callData !== "object") {
      return state;
    }

    return {
      ...state,
      callData:payload.callData,
    };
  });

export default reducer;



// WEBPACK FOOTER //
// ./src/services/calls/call.reducer.ts